<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.uid"
        placeholder="请输入用户ID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请选择状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择优惠券类型"
        clearable
        size="small"
        v-model="params.goodsType"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in goodsTypes"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="物品名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.goodsName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsOrigin"
        label="物品来源"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.goodsOrigin || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsType"
        label="物品类型"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.goodsType == 1">楼风解锁折扣卷</span>
          <span v-else-if="scope.row.goodsType == 2">会员折扣卷</span>
          <span v-else-if="scope.row.goodsType == 3">AI换脸折扣券</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsValue"
        label="物品价值"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.goodsValue || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="物品状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1">已使用</el-tag>
          <el-tag type="success" v-else-if="scope.row.status == 2"
            >未使用</el-tag
          >
          <el-tag type="info" v-else>过期</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="expiredTime"
        label="过期时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.expiredTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="useTime"
        label="使用时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.useTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.page"
      :page-size="params.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        page: 1,
        limit: 10,
        uid: undefined, // 用户ID
        status: undefined, // 状态
        goodsType: null
      },
      statuses: [
        {
          label: "已使用",
          value: 1,
        },
        {
          label: "未使用",
          value: 2,
        },
        {
          label: "过期",
          value: 3,
        },
      ],
      // 0_全部 1_楼凤折扣 2_会员折扣 3_ai换脸抵扣券 4_金币视频观影券 5_金币加赠券
      goodsTypes: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "楼凤折扣",
          value: 1,
        },
        {
          label: "会员折扣",
          value: 2,
        },
        {
          label: "ai换脸抵扣券",
          value: 3,
        },
        {
          label: "金币视频观影券",
          value: 4,
        },
        {
          label: "金币加赠券",
          value: 5,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.page = 1;
      }
      API.getBackpackList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.limit = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.page = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
